import { computed, getCurrentInstance } from "vue";

export type LanguageType =
  | "en_US"
  | "de_DE"
  | "es_ES"
  | "fr_FR"
  | "it_IT"
  | "pt_PT";

export default function useTranslations() {
  const instance = getCurrentInstance();
  const current = computed(() => instance?.proxy.$language.current);
  const available = computed(() => instance?.proxy.$language.available);
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const $t = instance!.proxy.$gettext!;

  const availableLanguages = computed<LanguageType[]>(
    () => Object.keys(instance!.proxy.$language.available) as LanguageType[]
  );

  const set = (language: LanguageType) => {
    if (instance?.proxy.$language.current) {
      instance.proxy.$language.current = language;
    }
  };

  const validate = (_language: string) => {
    let language = _language || "";
    // Map language if we receive language with 2 characters
    if (language.length === 2) {
      switch (language) {
        case "en":
          language = "en_US";
          break;
        case "de":
          language = "de_DE";
          break;
        case "es":
          language = "es_ES";
          break;
        case "fr":
          language = "fr_FR";
          break;
        case "it":
          language = "it_IT";
          break;
        case "pt":
          language = "pt_PT";
          break;
        default:
          language = "en_US";
      }
    }
    if (!availableLanguages.value.includes(language as LanguageType)) {
      console.group("Language validation");
      console.warn(
        !language
          ? 'Missing required prop: "_language"'
          : `_language prop doesn't match any of allowed languages`
      );
      console.table({
        "Current language": language || "Missing language property",
        "Allowed languages": availableLanguages.value.toString(),
      });
      console.groupEnd();
    } else if (language) {
      set(language as LanguageType);
    }
  };

  return { current, available, $t, set, validate };
}
